export const getRecaptchaToken = (siteKey: string, options?: { action?: string }): Promise<string> =>
  new Promise((resolve, reject) => {
    try {
      window.grecaptcha.ready(() => {
        try {
          window.grecaptcha.execute(siteKey, options).then(resolve, reject);
        } catch (error) {
          reject(error);
        }
      });
    } catch (error) {
      reject(error);
    }
  });
